import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_DOCUMENT } from "../../constants/modules"

import { documentQueryKeys } from "./queryKeys"
import { useDocumentQuery } from "./useDocumentQuery"

export function useDocumentProject(params = {}) {
    const { selectedNetwork } = useNetworksStateContext()

    const url = `projects/${selectedNetwork.slug}/`
    const queryParams = useExtendWithSubnetworks(params, API_MODULE_DOCUMENT)
    const queryKey = documentQueryKeys.project(queryParams)
    return useDocumentQuery(
        url,
        queryKey,
        queryParams,
    )
}